module.exports = __webpack_public_path__ + "static/media/processed.de69f326.svg";